import React, { useState } from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import { LinearProgress } from '@material-ui/core';
import { getTheme } from 'theme';
import DialogContent from '@material-ui/core/DialogContent';
import AppButtonMinimal from '../AppButtonMinimal';
import AppButtonMain from '../AppButtonMain';

const AppDialog = (
  {
    open,
    onClose,
    onKill,
    title,
    onSubmit,
    children,
  },
) => {
  const [ loading, setLoading ] = useState(false);

  const handleSubmit = () => {
    return Promise.resolve()
      .then(() => { setLoading(true); })
      .then(() => { return onSubmit(); })
      .finally(() => { setLoading(false); });
  };

  return (
    <Dialog keepMounted={ false } open={ open } onClose={ onClose } onExited={ onKill }>
      {loading && <LinearProgress />}
      <DialogTitle>
        {title}
      </DialogTitle>
      <DialogContent>
        {children}
      </DialogContent>
      <DialogContent>
        <div style={ { padding: getTheme().spacing(2, 0), display: 'flex', justifyContent: 'space-between', flexGrow: 1 } }>
          <AppButtonMinimal
            color={ getTheme().palette.error.main }
            text='Cancel'
            disabled={ loading }
            onClick={ onClose }
          />
          <AppButtonMain
            text='Submit'
            onClick={ handleSubmit }
            disabled={ loading }
          />
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default AppDialog;
